import type { MarlinStoreDb } from "../infra/db";
import * as ops from "./store";

const windowApi = (db: MarlinStoreDb, screenId: number) => ({
  getScreenLayoutTemplates: () => ops.getScreenLayoutTemplates(db),
  getScreenLayoutTemplate: (
    templateId: Parameters<typeof ops.getScreenLayoutTemplate>[1],
  ) => ops.getScreenLayoutTemplate(db, templateId),
  saveScreenLayoutTemplate: (
    name: Parameters<typeof ops.saveScreenLayoutTemplate>[1],
  ) => ops.saveScreenLayoutTemplate(db, name, screenId),
  deleteScreenLayoutTemplate: (
    templateId: Parameters<typeof ops.deleteScreenLayoutTemplate>[1],
  ) => ops.deleteScreenLayoutTemplate(db, templateId),
  loadScreenLayoutTemplate: (
    templateId: Parameters<typeof ops.loadScreenLayoutTemplate>[1],
  ) => ops.loadScreenLayoutTemplate(db, templateId, screenId),
  getSelectedScreenTemplateId: () =>
    ops.getSelectedScreenTemplateId(db, screenId),
  setSelectedScreenTemplateId: (
    templateId: Parameters<typeof ops.setSelectedScreenTemplateId>[1],
  ) => ops.setSelectedScreenTemplateId(db, templateId, screenId),
});

export const createScreenTemplatesApi = (
  db: MarlinStoreDb,
  screenId: number,
) => ({
  ...windowApi(db, screenId),
  forScreen: (id: number) => windowApi(db, id),
});

export type ScreenTemplatesApi = ReturnType<typeof createScreenTemplatesApi>;
